export default {
  bulkTags: [],
  bulkTagsUrl: '',
  status: {},
  references: [],
};